<vsf-layout [class.pdp-route]="isProductPage">
    <vsf-layout-header *ngIf="!(isSellerPortal$ | async)">
        <vsf-modal [visible]="categoriesVisible" (close)="closeAllMenus()" class="md:hidden">
            <div class="relative bg-white p-6 overflow-y-auto z-10 full-screen-modal">
                <div class="flex-1 overflow-y-auto p-6">
                    <vsf-collections-menu-mobile (closeModals)="closeAllMenus()"
                        (closeCategoriesModal)="closeCategories()" [visible]="categoriesVisible"
                        class="md:hidden text-sm font-medium text-black"></vsf-collections-menu-mobile>
                </div>
            </div>
        </vsf-modal>
        <vsf-modal [visible]="mobileMenuVisible" (close)="closeAllMenus()" class="md:hidden">
            <div class="relative bg-white p-6 overflow-y-auto z-10 full-screen-modal">
                <div class="flex justify-between items-center mb-6 border-b border-[#E5E8EC] pb-4">
                    <a [routerLink]="['/']" class="flex items-center">
                        <img alt="Venduro" class="h-8 w-auto" src="assets/icons/venduro-logo.svg" />
                    </a>
                    <button (click)="closeAllMenus()">
                        <img alt="Close Menu" src="assets/icons/close-icon.svg" />
                    </button>
                </div>

                <nav class="flex flex-col gap-6 text-[#444343] text-[16px] font-medium">
                    <a [routerLink]="['']" (click)="closeAllMenus()">Home</a>
                    <a [routerLink]="['/pricelists/pre-order']" (click)="closeAllMenus()">Pre-Orders</a>
                    <a [routerLink]="['/consolidated-feed']" (click)="closeAllMenus()">Consolidated Feed</a>
                    <a [routerLink]="['/pricelists/short-offer']" (click)="closeAllMenus()">Special Offers</a>
                    <a [routerLink]="['/brands']" (click)="closeAllMenus()">Brands</a>
                    <a routerLink="/lists" routerLinkActive="text-[#2E62D9]" ariaCurrentWhenActive="page" (click)="closeAllMenus()">My Lists</a>
                    <a [routerLink]="['']" fragment="why-venduro" (click)="closeAllMenus()">Why Venduro</a>
                    <a [routerLink]="['']" fragment="for-suppliers" (click)="closeAllMenus()">For Suppliers</a>
                    <a [routerLink]="['']" fragment="faq" (click)="closeAllMenus()">FAQ</a>
                    <a *ngIf="user" [routerLink]="['/seller']" (click)="closeAllMenus()">Switch to Seller</a>
                    <a (click)="contactForm.openModal(); closeAllMenus()" class="cursor-pointer">Contact Us</a>
                    <a *ngIf="user" [routerLink]="['/account']" (click)="closeAllMenus()">My Account</a>
                    <button (click)="
                            categoriesVisible = true; mobileMenuVisible = false
                        " class="flex justify-between items-center cursor-pointer">
                        <span>Categories</span>
                        <img src="../assets/icons/right-arrow-icon.svg" alt="Expand" class="w-4 h-4" />
                    </button>
                </nav>
                <div *ngIf="!user" class="mt-6 pt-4 border-t flex justify-between gap-3">
                    <button [routerLink]="['/account/sign-in']" (click)="closeAllMenus()"
                        class="flex-1 border border-black text-black text-[16px] font-medium py-2 rounded-md">
                        Sign In
                    </button>
                    <button [routerLink]="['/account/register']" (click)="closeAllMenus()"
                        class="flex-1 bg-brand-primary text-white py-2 rounded-md text-white text-[16px] font-medium">
                        Sign Up
                    </button>
                </div>
                <div *ngIf="user" class="mt-6 pt-4 border-t flex justify-between gap-3">
                    <button (click)="signOut()"
                        class="flex-1 border border-red-500 text-red-500 hover:bg-red-50 py-2 rounded-md text-[16px] font-medium">
                        Logout
                    </button>
                </div>
            </div>
        </vsf-modal>

        <div *ngIf="isHomePage$ | async" class="hidden md:block bg-[#0a1324] text-[#aeb8cc] text-[11.5px]">
            <div class="max-w-7xl mx-auto h-[34px] px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-7">
                <span class="flex items-center gap-[6px]">
                    <img src="assets/icons/utility-shield.svg" alt="" class="w-3 h-3" />
                    Fast Shipping &amp; Protection
                </span>
                <span class="flex items-center gap-[6px]">
                    <img src="assets/icons/utility-shield.svg" alt="" class="w-3 h-3" />
                    100% Authenticity Guarantee
                </span>
                <span class="flex items-center gap-[6px]">
                    <img src="assets/icons/utility-shield.svg" alt="" class="w-3 h-3" />
                    All Suppliers Fully Vetted
                </span>
            </div>
        </div>

        <!-- MAIN HEADER -->
        <div class="bg-white border-b border-[#e6e9ef]">
            <!-- Mobile Header -->
            <div class="site-mobile-header md:hidden">
                <div class="site-mobile-header__bar">
                    <button
                        type="button"
                        class="site-mobile-header__menu"
                        (click)="toggleMobileMenu()"
                        aria-label="Open menu"
                    >
                        <span></span><span></span><span></span>
                    </button>
                    <a [routerLink]="['/']" class="site-mobile-header__logo">
                        <img src="assets/icons/venduro-logo.svg" alt="Venduro" />
                    </a>
                    <div class="site-mobile-header__actions">
                        <a *ngIf="user" [routerLink]="['/account']" class="site-mobile-header__profile" aria-label="My account">
                            <img src="assets/icons/profile-icon.svg" alt="" />
                        </a>
                        <a *ngIf="!user" [routerLink]="['/account/sign-in']" class="site-mobile-header__profile" aria-label="Sign in">
                            <img src="assets/icons/profile-icon.svg" alt="" />
                        </a>
                        <vsf-cart-toggle (toggle)="navigateToCart()"></vsf-cart-toggle>
                    </div>
                </div>
                <div class="site-mobile-header__search">
                    <vsf-product-search-bar class="w-full"></vsf-product-search-bar>
                </div>
            </div>

            <div class="site-desktop-header site-header-top hidden md:flex max-w-7xl mx-auto h-[74px] px-4 sm:px-6 lg:px-8 items-center gap-[22px]">
                <a [routerLink]="['/']">
                    <img src="assets/icons/venduro-logo.svg" alt="Venduro" class="h-[23px] block">
                </a>
                <div class="site-header-search flex-1 flex justify-center px-4">
                    <vsf-product-search-bar class="w-full max-w-[620px]"></vsf-product-search-bar>
                </div>
                <div class="flex items-center gap-[20px]">
                    <vsf-cart-toggle (toggle)="navigateToCart()"></vsf-cart-toggle>
                    <vsf-account-link></vsf-account-link>
                </div>
            </div>

            <div
                class="site-header-nav hidden md:flex max-w-7xl mx-auto h-[46px] px-4 sm:px-6 lg:px-8 items-center justify-center gap-1 text-[13.5px] font-medium text-[#3c4454] border-t border-[#e6e9ef]">
                <a [routerLink]="['/category/products']"
                    class="flex items-center h-8 px-[14px] rounded-lg cursor-pointer hover:bg-[#f2f5fb] hover:text-[#2E62D9]">Health
                    and Beauty</a>
                <a [routerLink]="['/pricelists/pre-order']"
                    class="flex items-center h-8 px-[14px] rounded-lg cursor-pointer hover:bg-[#f2f5fb] hover:text-[#2E62D9]">Pre-Orders</a>
                <a [routerLink]="['/consolidated-feed']"
                    class="flex items-center h-8 px-[14px] rounded-lg cursor-pointer hover:bg-[#f2f5fb] hover:text-[#2E62D9]">
                    Consolidated Feed
                    <span class="ml-1.5 inline-flex items-center h-[18px] px-1.5 rounded-full bg-[#dbe6fb] text-[#2E62D9] text-[10px] font-bold tracking-wide">NEW</span>
                </a>
                <a [routerLink]="['/pricelists/short-offer']"
                    routerLinkActive="bg-[#f2f5fb] text-[#2E62D9]"
                    ariaCurrentWhenActive="page"
                    class="flex items-center h-8 px-[14px] rounded-lg cursor-pointer hover:bg-[#f2f5fb] hover:text-[#2E62D9]">Special Offers</a>
                <a [routerLink]="['/brands']"
                    class="flex items-center h-8 px-[14px] rounded-lg cursor-pointer hover:bg-[#f2f5fb] hover:text-[#2E62D9]">Brands</a>
                <a routerLink="/lists"
                    routerLinkActive="bg-[#f2f5fb] text-[#2E62D9]"
                    ariaCurrentWhenActive="page"
                    class="flex items-center h-8 px-[14px] rounded-lg cursor-pointer hover:bg-[#f2f5fb] hover:text-[#2E62D9]">My Lists</a>
            </div>
        </div>
    </vsf-layout-header>
    <vsf-collections-menu-mobile [visible]="mobileNavVisible$ | async" class="z-10"></vsf-collections-menu-mobile>
    <vsf-cart-drawer [visible]="cartDrawerVisible$ | async"></vsf-cart-drawer>
    <div class="contents" [class.seller-portal-route]="isSellerPortal$ | async">
        <vsf-home-page *ngIf="isHomePage$ | async; else main"></vsf-home-page>
        <ng-template #main>
            <router-outlet></router-outlet>
        </ng-template>
    </div>

    <vsf-layout-footer *ngIf="!(isSellerPortal$ | async)">
        <footer id="contact-us" class="bg-[#0a1324] pt-14 pb-8">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1 md:grid-cols-[1.5fr_1fr_1fr_1.2fr] gap-8 md:gap-[34px]">
                    <div>
                        <a [routerLink]="['/']">
                            <img src="assets/icons/venduro-logo.svg" alt="Venduro"
                                class="h-[21px] block filter brightness-0 invert">
                        </a>
                        <p class="text-[13px] leading-[1.65] text-[#7c879b] mt-[14px] max-w-[250px]">
                            B2B wholesale marketplace for verified European suppliers. Transparent offers, trackable
                            orders and clear support.
                        </p>
                        <div class="flex gap-[10px] mt-[18px]">
                            <span
                                class="inline-flex items-center h-[26px] px-[11px] border border-[#24344f] rounded-md text-[11px] font-semibold text-[#aeb8cc]">GDPR
                                compliant</span>
                            <span
                                class="inline-flex items-center h-[26px] px-[11px] border border-[#24344f] rounded-md text-[11px] font-semibold text-[#aeb8cc]">Order
                                tracking</span>
                        </div>
                    </div>
                    <div class="flex flex-col gap-[11px]">
                        <h3 class="text-[11.5px] font-bold tracking-[0.1em] text-[#5f6d85] uppercase">Marketplace</h3>
                        <a [routerLink]="['/category', 'health-beauty']"
                            class="text-[13.5px] text-[#a7b1c4] hover:text-white cursor-pointer">Health & Beauty
                            Catalog</a>
                        <a [routerLink]="['/category/trending-offers']"
                            class="text-[13.5px] text-[#a7b1c4] hover:text-white cursor-pointer">Trending Offers</a>
                        <a [routerLink]="['/pricelists/pre-order']"
                            class="text-[13.5px] text-[#a7b1c4] hover:text-white cursor-pointer">Pre-Order
                            Opportunities</a>
                    </div>
                    <div class="flex flex-col gap-[11px]">
                        <h3 class="text-[11.5px] font-bold tracking-[0.1em] text-[#5f6d85] uppercase">Company</h3>
                        <a [routerLink]="['/about']"
                            class="text-[13.5px] text-[#a7b1c4] hover:text-white cursor-pointer">About & investors</a>
                        <a [routerLink]="['/terms']"
                            class="text-[13.5px] text-[#a7b1c4] hover:text-white cursor-pointer">Terms & Conditions</a>
                        <a [routerLink]="['/privacy']"
                            class="text-[13.5px] text-[#a7b1c4] hover:text-white cursor-pointer">Privacy Policy</a>
                    </div>
                    <div>
                        <h3 class="text-[11.5px] font-bold tracking-[0.1em] text-[#5f6d85] uppercase">Contact</h3>
                        <p class="text-[13.5px] leading-[1.65] text-[#a7b1c4] mt-[11px]">
                            Support for sourcing, orders and disputes during business days.
                        </p>
                        <button (click)="contactForm.openModal()"
                            class="inline-flex items-center justify-center h-[40px] px-5 bg-[#2E62D9] text-white rounded-lg text-[13.5px] font-semibold mt-4 cursor-pointer hover:bg-[#1e4bb0] w-fit">
                            Contact us
                        </button>
                    </div>
                </div>
                <div
                    class="border-t border-[#1d2c45] mt-[42px] pt-5 text-[12.5px] text-[#5f6d85] text-center md:text-left">
                    © {{ currentYear }} Venduro. All rights reserved. · Amsterdam · Vilnius
                </div>
            </div>
        </footer>
    </vsf-layout-footer>
    <vsf-contact-form #contactForm></vsf-contact-form>
</vsf-layout>
